import { render, staticRenderFns } from "./ChildEntityDataWidget.vue?vue&type=template&id=0ac17ff9&"
import script from "./ChildEntityDataWidget.vue?vue&type=script&lang=js&"
export * from "./ChildEntityDataWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChildEntityDataWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VDialog})
